export default __webpack_public_path__ + "static/drukarki_dzierzawa_l6570-581572f896d25dd123cb3c92db9014c0.png";